// extracted by mini-css-extract-plugin
export default {"item":"ThreeDotMenu_item__2U0wr","menu":"ThreeDotMenu_menu__1-Qrr","menuList":"ThreeDotMenu_menuList__1DaEz","section":"ThreeDotMenu_section__2ezot"};